<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<well-local-address-list
  [localAddresses]="localAddresses | async "
  (addressSelect)="onSelect($event)"
>

</well-local-address-list>


